document.querySelectorAll('.JournalIndexBlock__list-load button').forEach((btn) => {
    btn.addEventListener('click', () => {
        btn.setAttribute('disabled', '1');
        const listEl = btn.parentElement.parentElement;
        fetch(btn.dataset.url).then(d => d.text()).then((html) => {
            btn.parentElement.outerHTML = html;
            setTimeout(() => {
                Array.from(listEl.children).forEach((el) => {
                    el.classList.remove('JournalItemSmall--hide');
                })
            }, 100);
        });
    });
})
